export const DEFAULT_FALLBACK_IMG =
  'https://st2.depositphotos.com/1560768/6162/i/950/depositphotos_61621057-stock-photo-no-image-available.jpg';

export const WORKOUT_PREVIEW_FALLBACK_IMG =
  'https://media.istockphoto.com/photos/bodybuilder-performing-power-lift-curl-picture-id181894126?k=20&m=181894126&s=612x612&w=0&h=-Sz5JAGc66ztJUEDwtSHaEA6n59Lnl19zmrw5iL-gkc=';
